// extracted by mini-css-extract-plugin
export default {"wrapper":"AdditionalTitle_wrapper__7bDkI","icon":"AdditionalTitle_icon__NdKfn","collapsed":"AdditionalTitle_collapsed__0DaEo"};